import { render, staticRenderFns } from "./EnrolleeIDCard.vue?vue&type=template&id=3ab21f7b&scoped=true&"
import script from "./EnrolleeIDCard.vue?vue&type=script&lang=js&"
export * from "./EnrolleeIDCard.vue?vue&type=script&lang=js&"
import style0 from "./EnrolleeIDCard.vue?vue&type=style&index=0&id=3ab21f7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab21f7b",
  null
  
)

export default component.exports